import initialState from './initialState';
import { reducer as loadEventsReducer } from './loadEvents';
import { reducer as loadEventDetailReducer } from './loadEventDetail';
import { reducer as loadPageContentReducer } from './loadPageContent';
import { reducer as loadPagesInEventReducer } from './loadPagesInEvent';
import { reducer as loadDefaultPageReducer } from './loadDefaultPage';
import { reducer as loadCollectionsInEventReducer } from './loadCollectionsInEvent';
import { reducer as loadSnippetsInEventReducer } from './loadSnippetsInEvent';
import { reducer as closeActionFormModalReducer } from './closeActionFormModal';
import { reducer as deleteActionReducer } from './deleteAction';
import { reducer as deleteEventReducer } from './deleteEvent';
import { reducer as openActionPropModalReducer } from './openActionPropModal';
import { reducer as saveNewActionReducer } from './saveNewAction';
import { reducer as saveNewEventReducer } from './saveNewEvent';
import { reducer as updateActionReducer } from './updateAction';
import { reducer as updateEventReducer } from './updateEvent';
import { reducer as toggleEventUpdateReducer } from './toggleEventUpdate';
import { reducer as loadProjectPluginsReducer } from './loadProjectPlugins';
import { reducer as swapActionStepReducer } from './swapActionStep';
import { reducer as openActionEnableModalReducer } from './openActionEnableModal';
import { reducer as closeActionEnableModalReducer } from './closeActionEnableModal';
import { reducer as enableActionReducer } from './enableAction';
import { reducer as loadProjectDetailEventReducer } from './loadProjectDetailEvent';
import { reducer as loadDatasourcesInEventReducer } from './loadDatasourcesInEvent';
import { reducer as getPermissionFlagsReducer } from './getPermissionFlags';

const reducers = [
  loadEventsReducer,
  loadEventDetailReducer,
  loadPageContentReducer,
  loadPagesInEventReducer,
  loadDefaultPageReducer,
  loadCollectionsInEventReducer,
  loadSnippetsInEventReducer,
  closeActionFormModalReducer,
  deleteActionReducer,
  deleteEventReducer,
  openActionPropModalReducer,
  saveNewActionReducer,
  saveNewEventReducer,
  updateActionReducer,
  updateEventReducer,
  toggleEventUpdateReducer,
  loadProjectPluginsReducer,
  swapActionStepReducer,
  openActionEnableModalReducer,
  closeActionEnableModalReducer,
  enableActionReducer,
  loadProjectDetailEventReducer,
  loadDatasourcesInEventReducer,
  getPermissionFlagsReducer,
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    // Handle cross-topic actions here
    default:
      newState = state;
      break;
  }
  return reducers.reduce((s, r) => r(s, action), newState);
}
